export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'

export const GET_POSTS = 'GET_POSTS'

export const OPEN_SEARCH = 'OPEN_SEARCH'
export const CLOSE_SEARCH = 'CLOSE_SEARCH'
export const GET_QUERY = 'GET_QUERY'
